import { useState, useEffect } from 'react';
import ZTM_API_BASE from '../services/ztmApi';

export default function useVehicles(refreshInterval = 10000) {
  const [vehicles, setVehicles] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const response = await fetch(`${ZTM_API_BASE}/gpsPositions?v=2`);
        const data = await response.json();
        setVehicles(data.vehicles || []);
        setLastUpdated(new Date());
      } catch (error) {
        console.error('Błąd podczas pobierania pozycji pojazdów:', error);
      }
    };

    fetchVehicles();
    const interval = setInterval(fetchVehicles, refreshInterval);
    return () => clearInterval(interval);
  }, [refreshInterval]);

  return { vehicles, lastUpdated };
}
